/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_Zarpar_TitleInputs */

const es_landing_price_zarpar_title = /** @type {(inputs: Landing_Price_Zarpar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión Zarpar`)
};

const gl_landing_price_zarpar_title = /** @type {(inputs: Landing_Price_Zarpar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xestión Zarpar`)
};

const en_landing_price_zarpar_title = /** @type {(inputs: Landing_Price_Zarpar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar management`)
};

/**
* | output |
* | --- |
* | "Zarpar management" |
*
* @param {Landing_Price_Zarpar_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_zarpar_title = /** @type {((inputs?: Landing_Price_Zarpar_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_Zarpar_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_zarpar_title(inputs)
	if (locale === "en") return en_landing_price_zarpar_title(inputs)
	return es_landing_price_zarpar_title(inputs)
});